import {
    faHandsHoldingHeart,
    faHandshake,
    faListCheck,
    faMessageDots,
    faPage,
    faPhone,
    faSend,
} from '@fortawesome/pro-regular-svg-icons';
import { CreatedByLabel } from 'assets/js/pages/contacts/single/timeline/timeline-list/item/components/CreatedByLabel';
import { ContactType } from 'constants/contacts';
import { ActivityItem, Contact } from 'types/domain';

const getConfigs = (item: ActivityItem, contact: Contact) => {
    const { name_display = '', first_name_display = '', company_name = '' } = contact;
    const fullName = contact.type === ContactType.Company ? company_name : name_display;
    const firstName = contact.type === ContactType.Company ? company_name : first_name_display;

    if (item.type === 'email')
        return {
            icon: faSend,
            text: (
                <p>
                    <CreatedByLabel createdBy={item.created_by} /> sent{' '}
                    <span className="font-medium">{fullName}</span> an email
                </p>
            ),
        };
    if (item.type === 'sms')
        return {
            icon: faMessageDots,
            text: (
                <p>
                    <CreatedByLabel createdBy={item.created_by} /> sent{' '}
                    <span className="font-medium">{fullName}</span> a text message
                </p>
            ),
        };
    if (item.type === 'completed_task')
        return {
            icon: faListCheck,
            text: (
                <p>
                    <CreatedByLabel createdBy={item.created_by} /> completed a task relating to{' '}
                    <span className="font-medium">{fullName}</span>
                </p>
            ),
        };
    if (item.type === 'volunteer_activity')
        return {
            icon: faHandsHoldingHeart,
            text: <p>Volunteered</p>,
        };
    if (item.type === 'note')
        return {
            icon: faPage,
            text: (
                <p>
                    <CreatedByLabel createdBy={item.created_by} /> added a note to{' '}
                    <span className="font-medium">{firstName}'s </span> timeline
                </p>
            ),
        };
    if (item.type === 'meeting')
        return {
            icon: faHandshake,
            text: (
                <p>
                    <CreatedByLabel createdBy={item.created_by} /> met with{' '}
                    <span className="font-medium">{`${fullName}`}</span>
                </p>
            ),
        };
    return {
        icon: faPhone,
        text: (
            <p>
                <CreatedByLabel createdBy={item.created_by} /> called{' '}
                <span className="font-medium">{fullName}</span> on the phone
            </p>
        ),
    };
};

export { getConfigs };
